<template>
  <h3 class="text-base font-semibold leading-6 text-gray-800">
    <slot>Sous-titre</slot>
  </h3>
</template>
